import { countries } from "@/app/infrastructures/misc/BulkData";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { BulkBookingController } from "@/app/ui/controllers/BulkBookingController";

export const getValueOrString = (value: any) => {
  return value || ""
}

export const listBulkBooking = () => {
  return {
    isFirstRequest: BulkBookingController.isFirstRequest,
    dataTable: BulkBookingController.bulkBookingList.data,
    isLoading: BulkBookingController.isLoading,
    accountType: AccountController.accountData.account_type
  }
}

export const downloadSuccessBulkBooking = (id: number) => {
  BulkBookingController.downloadSuccessBulkBooking(id);
}

export const downloadFailedBulkBooking = (id: number) => {
  BulkBookingController.downloadFailedFileV2(id);
}

export const setBulkBookingListFirstPage = () => {
  BulkBookingController.setFirstPage();
}

const phoneWithoutPlus = (phone: string) => {
  return phone?.startsWith("+") ? phone.substring(1) : phone
}

export const codePhoneCountry = (phone: string) => {
  const trimPhone = phoneWithoutPlus(phone)
  let code = "";
  let flag = "";
  let newPhone = phone;

  for (const item of countries) {
    if (trimPhone?.startsWith(item.code.substring(1))) {
      code = item.code;
      flag = item.flag;
      newPhone = trimPhone.substring(item.code?.length - 1, trimPhone?.length);
    }
  }

  return {
    code: code,
    flag: flag,
    number: newPhone?.startsWith("0") ? newPhone.substring(1) : newPhone
  };

};


export const errorRepairPosition = [
  { name: 'shipmentId', position: 'repair-shipment-id' },
  { name: 'manualSttNumber', position: '' },
  { name: 'externalNumber', position: 'repair-external-number' },
  { name: 'shipperPhoneNumber', position: 'repair-sender-phone' },
  { name: 'shipperName', position: 'repair-sender-name' },
  { name: 'shipperAddress', position: 'field_address_sender_booking' },
  { name: 'originDistrictName', position: 'repair-sender-district' },
  { name: 'consigneePhone', position: 'repair-recipient-phone' },
  { name: 'consigneeName', position: 'repair-recipient-name' },
  { name: 'consigneeAddress', position: 'repair-recipient-address' },
  { name: 'destinationDistrictName', position: 'repair-recipient-district' },
  { name: 'destinationPostalCode', position: 'repair-recipient-postal' },
  { name: 'consigneesAddressType', position: 'repair-recipient-address-type' },
  { name: 'serviceType', position: 'repair-service-type' },
  { name: 'codAmount', position: 'repair-cod-amount' },
  { name: 'insuranceFlag', position: 'repair-insurance' },
  { name: 'commodityCode', position: 'repair-commodity-code' },
  { name: 'woodPacking', position: 'repair-woodpacking' },
  { name: 'valueOfGoods', position: 'repair-good-value' },
  { name: 'productType', position: 'repair-render-poster' },
  { name: 'totalPieces', position: 'repair-total-pieces' },
  { name: 'totalWeight', position: 'repair-total-pieces' },
  { name: 'note', position: ''},
  { name: 'dutyTaxTerms', position: 'booking-repair-cipl-select-duty-tax-terms' }
];

